module.exports = [{"name":"Цель 1","type":"action","conditions":[{"type":"exact","url":"ru1"}]},{"name":"Цель 2","type":"action","conditions":[{"type":"exact","url":"ru2"}]},{"name":"Цель 3","type":"action","conditions":[{"type":"exact","url":"ru3"}]}]


//////////////////
// WEBPACK FOOTER
// ./temp/components/tracking/.variant/base/goalsConfigs/ar/en/yandex.yaml
// module id = 89
// module chunks = 1